import { render, staticRenderFns } from "./HistoryOverview.vue?vue&type=template&id=0cf05909&"
import script from "./HistoryOverview.vue?vue&type=script&lang=js&"
export * from "./HistoryOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports